export const getPreviewText = (text) => {
  if (!text) return "";

  // Split text into words and form two lines.
  const lines = text.split("\n"); // Split based on new lines (if present)

  // If there are more than two lines, we only show the first two.
  const firstTwoLines = lines.slice(0, 2).join("\n");

  return (
    <>
      {firstTwoLines}
      {text.length > firstTwoLines.length && " ..."} {/* Add ellipsis if the message is longer */}
    </>
  );
};
